import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import marked from 'marked';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.typography.body1,
    fontFamily: ['Euclid Square', 'sans-serif'].join(','),
    display: 'block',
    '& h1': {
      ...theme.typography.h1,
      color: theme.palette.facet.primaryBlue,
    },
    '& h2': {
      ...theme.typography.h2,
      color: theme.palette.facet.primaryBlue,
    },
    '& h3': {
      ...theme.typography.h3,
      color: theme.palette.facet.primaryBlue,
    },
    '& h4': {
      ...theme.typography.h4,
      color: theme.palette.facet.primaryBlue,
    },
    '& h5': {
      ...theme.typography.h5,
      color: theme.palette.facet.primaryBlue,
    },
    '& h6': {
      ...theme.typography.h6,
      color: theme.palette.facet.primaryBlue,
    },
  },
}));

const MarkdownDisplay = React.forwardRef((props, ref) => {
  const {
    value, className, ...rest
  } = props;
  const classes = useStyles();

  const html = marked(value, { breaks: true, gfm: true });
  return (
  // eslint-disable-next-line
    <div dangerouslySetInnerHTML={{ __html: html }} ref={ref} className={classNames(classes.root, {
      [className]: Boolean(className),
    })} {...rest}
    />
  );
});

MarkdownDisplay.propTypes = {
  value: PropTypes.string,
  className: PropTypes.string,
};
MarkdownDisplay.defaultProps = {
  value: '',
  className: undefined,
};

export default MarkdownDisplay;
